import axios from 'axios'

/**
 * Axios config
 */
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    return Promise.reject(responseValidate(error))
  }
)

function responseValidate(error) {
  if (!error.response) {
    return 'server not responding'
  }
  if (error.response.status == 401) {
    window.location.href = '/login' //just redirect to login page
    return 'API Token Expire'
  }
  if (error.response.status == 403) { //not authorized
    return 'Access Denied'
  }
  if (error.response.status == 419) { //session expire
    window.location.href = '/login' //just redirect to login page
    return 'Refresh page!'  //CSRF Token Expoire
    // return 'Security Token Expire! Refresh this page.'  //CSRF Token Expoire
  }

  // if (error.response.data) {
  //   return error.response.data
  // }

  // if (error.response) {
  //   return status[error.response.status]
  // }

  return error
}

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
}

export { axios }
